import React from 'react'
import './DashNavbar.scss';
import { NavLink } from "react-router-dom";
import logodash from '../../Images/logodash.svg'
import profilepic from '../../Images/pfp.png'
import logout from '../../Images/logout.svg'
// import Scrollspy from 'react-scrollspy'

const DashNavbar = ({ homeNav }) => {
    return (
        <div id='navbardash'>
            <nav className={homeNav}>
                <div className="container-fluid navbarWidth">
                    <a href="/"><img className="navlogo" src={logodash} alt="logo" /></a>
                    <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarCollapse"
                        aria-controls="navbarCollapse" aria-expanded="false" aria-label="Toggle navigation">
                        <span className="navbar-toggler-icon"></span>
                    </button>
                    <div className="collapse navbar-collapse" id="navbarCollapse">
                        <ul
                            className="navbar-nav me-auto ps-2 mt-1 mb-md-0" >
                            <li className="nav-item ms-md-3">
                                <NavLink className="nav-link" to="/dashboard/home">Home</NavLink>
                            </li>
                            <li className="nav-item ms-md-3">
                                <NavLink className="nav-link" to="/dashboard/isp">ISP</NavLink>
                            </li>
                            {/* <li className="nav-item ms-md-3">
                                <NavLink className="nav-link" to="/dashboard/residential">Residential</NavLink>
                            </li> */}
                        </ul>
                        <form className="d-flex">
                            <a href="/home">
                                <div className="dashboardButton text-nowrap">
                                    <div>
                                        <img className="navprofile" src={profilepic} alt="pfp" />
                                    </div>
                                    <div className='logoutWrapper'>
                                        <img className="nav-logout" src={logout} alt="logout" />
                                    </div>
                                </div>
                            </a>
                        </form>
                    </div>
                </div>
            </nav>
        </div>
    )
}

export default DashNavbar
